import {ReportStatus} from './IngestReportTypes';

export function getStatusColorClass(message: ReportStatus | string) {
    if (!message)
        return 'default';
    
    const messageFormatted = message.toUpperCase();
    
    if (/^(PASSED|SUCCESS)$/.test(messageFormatted))
        return 'success';
    
    if (/^(FAILED|ERROR)$/.test(messageFormatted))
        return 'failure';
    
    if (/^WARNING$/.test(messageFormatted))
        return 'warning';
    
    return 'default';
}

